import generalConfigurationApi from '@/api/general-configuration.api';

export const generalConfigurationService = (function () {
  'use strict';

  /**
   * Para obtener la configuración general a partir de una key
   */
  async function getByKey(key) {
    const result = await generalConfigurationApi.getByKey(key)
    return result.data
  }

  /**
   * Para Crear o Actualizar la configuración general a partir de una key
   */
  async function setByKey(key, data) {
    const result = await generalConfigurationApi.setByKey(key, data)
    return result.status
  }


  async function getLegalPersonTypes() {
    const result = await generalConfigurationApi.getLegalPersonTypes();
    const legalPersonTypes = result.map((type) => {
      return { id: type, name: type };
    });
    return legalPersonTypes;
  }

  return {
    getByKey,
    getLegalPersonTypes,
    setByKey
  }
})();
